import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import "./assets/font/font.scss";
import "./assets/public.css";
import "./assets/hmlapi.js";
Vue.config.productionTip = false;
router.replace("/"); // 路由重定向，刷新页面回到首页
import { backButton,swiperList } from "./components";
Vue.use(backButton);
Vue.use(swiperList);
import { initBaiduTongji } from "./assets/hmlapi.js";
initBaiduTongji("d599dbe8b0725eb6542c8ee50c4cefc5");

// import BaiduMap from 'vue-baidu-map';

// Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'rGhPoeI5SWfwdu2XoUx6RtGRKIomBk9a'
// })
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: '4d6cd7f83dfbf7e023392e89890144f7',
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','MarkerClusterer'],
    // 默认高德 sdk 版本为 1.4.4  
    v: '1.4.4'
});


router.beforeEach((to, from, next) => {
    if (to.path) {
        // _hmt.push(['_trackPageview',to.name]);
         // console.log(_hmt);
    }
    next()
})


const vue = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

Vue.prototype.ICON = require("@/assets/img/Icon.png");
Vue.prototype.RJBG = require("@/assets/img/secondLevelPage/renjieBg.jpg");
Vue.prototype.getImgSrc = (value,state) => {
    const imgReg = /<img.*?(?:>|\/>)/gi;
    const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
    if (value) {
        try {
            let array = value.match(imgReg); // 将所有图片存入数组
            let imgArray;
            if(state){
                imgArray = [];
            }
            for (var j = 0; j < array.length; j++) { // 循环数组
                var src = array[j].match(srcReg); // 利用正则分割图片字符串
                // 获取图片地址
                if (src[1]) { // 判断分割后数组路径是否存在
                    if (state) {
                        imgArray.push(src[1]); // 将路径存储进数组
                    } else {
                        // 返回图片路径
                        return src[1];
                    }
                }
            }
            if(state){
                return imgArray;
            }
        } catch (e) {
            // console.log("图片路径处理出错", e);
        }
    }

}


Vue.prototype.GetRequest = () => {
    let url = decodeURI(location.search); //获取url中"?"符后的字串
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
        let str = url.substr(1);
        let strs = str.split("&");
        for(let i = 0; i < strs.length; i ++) {
            theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}






function isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();
    // 判断是否在微信中打开
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}

function renderResize() {
    // 横屏
    let basesZoom = 375 / 667; // 标准比例
    let clientWidth = window.document.documentElement.clientWidth;
    let clientHeight = window.document.documentElement.clientHeight;
    let docEl = document.documentElement; // 获取 html 节点
    let transefromRemHandle = function (preWidth) {
        let fontEl = document.createElement("style");
        let base = 100;
        return function () {
            if (isWeiXin()) {
                clientHeight = clientHeight + 64;
            }

            let domStantd = clientWidth / clientHeight; // 当前屏幕比例
            let zoom = basesZoom / domStantd; // 标准比例除当前屏幕比例
            let rem;
            docEl.setAttribute("data-rem", rem);
            if (zoom > 1) { // 标准比例除当前屏幕比例大于1按宽度计算rem
                rem = (clientWidth / preWidth) * base;
                fontEl.innerHTML = "html{font-size:" + rem + "px!important;}";
                docEl.setAttribute("data-rem", rem);
            } else { // 标准比例除当前屏幕比例小于1按高度计算rem
                rem = (clientHeight / 1334) * base;
                fontEl.innerHTML = "html{font-size:" + rem + "px!important;}";
                docEl.setAttribute("data-rem", rem);
            }
            docEl.firstElementChild && docEl.firstElementChild.appendChild(fontEl);
        };
    };
    let num = 750;
    transefromRemHandle(num)();
    let windowResize = window.onresize;
    window.onresize = function (e) {
        windowResize != null && windowResize.bind(this);
        transefromRemHandle(num)();
    };
}
try {
    renderResize();
    window.addEventListener("resize", renderResize, false)
} catch (e) {
     // console.log(e);
}